module.exports = __webpack_public_path__ + "static/media/tickRed.7b2f01dc.svg";